module.exports = __webpack_public_path__ + "static/media/School_Workspace_Class_Import_Template.a9bb15c4.xlsx";